module.exports = __webpack_public_path__ + "static/ML_hero-blog-image-c09af04cabc7d5bddc5d376bf919cb77.jpg";